<template>
	<div class="_layout001">
		<header class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
			<a class="navbar-brand col-md-3 col-lg-2 me-0 px-3">
				<router-link to="/" class="_paas_title">닷 개발자 사이트</router-link>	
			</a>
			<button class="navbar-toggler position-absolute d-md-none collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<ul class="navbar-nav px-3">
				<li class="nav-item text-nowrap">
					<router-link to="/login" class="nav-link">로그아웃</router-link>
				</li>
			</ul>
		</header>
		<div class="container-fluid">
			<div class="row">
				<nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
					<div class="position-sticky">
						<LeftMenu></LeftMenu>
					</div>
				</nav>
				<main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
					<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
						<h1 class="h2">{{ $route.meta.title }}</h1>
					</div>
					<router-view />
				</main>
			</div>
		</div>
	</div>
</template>
<script>
	import "@/assets/css/layout.css";
	import "@/assets/css/contents.css";
	import LeftMenu from "./LeftMenu"

	export default 
	{
		components: 
		{
			LeftMenu
		},
	}	
</script>
<style>
	._layout001 ._paas_title {
		color: white !important;
		font-size: 13pt;
	}
</style>
